import { FormEvent, useState } from "react"
import { marketingCapturePassword, unlockMarketingCapture } from "./guard"

export default function MarketingCaptureGate() {
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const configured = Boolean(marketingCapturePassword())

  const onSubmit = (event: FormEvent) => {
    event.preventDefault()
    if (!configured) {
      setError("Capture overlay is not configured on this environment.")
      return
    }
    if (!unlockMarketingCapture(password)) {
      setError("That password is incorrect.")
      return
    }
    setError("")
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f6fb",
        padding: 24,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: "100%",
          maxWidth: 400,
          background: "#fff",
          borderRadius: 16,
          padding: "28px 24px",
          boxShadow: "0 18px 50px rgba(17, 24, 39, 0.08)",
          fontFamily: "Manrope, Inter, sans-serif",
        }}
      >
        <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "#64748b" }}>
          Internal
        </div>
        <h1 style={{ margin: "8px 0 8px", fontSize: 22, color: "#0f172a" }}>Marketing capture</h1>
        <p style={{ margin: "0 0 20px", fontSize: 14, color: "#64748b", lineHeight: 1.5 }}>
          Sign-in is not enough. Enter the capture password to open dummy screenshot overlays.
        </p>
        <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#0f172a", marginBottom: 8 }}>
          Password
          <input
            type="password"
            autoFocus
            value={password}
            onChange={(event) => {
              setPassword(event.target.value)
              setError("")
            }}
            style={{
              display: "block",
              width: "100%",
              marginTop: 8,
              height: 40,
              borderRadius: 10,
              border: "1px solid #e5e7eb",
              padding: "0 12px",
              fontSize: 14,
              boxSizing: "border-box",
            }}
          />
        </label>
        {error ? (
          <div style={{ color: "#b42318", fontSize: 13, marginBottom: 12 }}>{error}</div>
        ) : null}
        <button
          type="submit"
          style={{
            width: "100%",
            height: 40,
            border: 0,
            borderRadius: 10,
            background: "#1664ff",
            color: "#fff",
            fontWeight: 700,
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          Continue
        </button>
      </form>
    </div>
  )
}
